import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/settings/refunds/cancellation-policy/$policyId")({
  component: lazyRouteComponent(() => import("./+EditPolicy")),
  beforeLoad: () => ({
    breadcrumb: "Cancellation Policy",
  }),
});
